import { render, staticRenderFns } from "./Scrolly.vue?vue&type=template&id=9b49a67a"
import script from "./Scrolly?vue&type=script&lang=js&external"
export * from "./Scrolly?vue&type=script&lang=js&external"
import style0 from "./Scrolly.vue?vue&type=style&index=0&id=9b49a67a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports